export function AvatarIconHover() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <title>A v a t a r I c o n H o v e r</title>
      <mask
        id="mask0_986_6136"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <circle cx="24" cy="24" r="20" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48 24C48 37.25 37.25 48 24 48C10.75 48 0 37.25 0 24C0 10.75 10.75 0 24 0C37.25 0 48 10.75 48 24ZM24 44C35.05 44 44 35.05 44 24C44 12.95 35.05 4 24 4C12.95 4 4 12.95 4 24C4 35.05 12.95 44 24 44Z"
          fill="black"
          fillOpacity="0.12"
        />
      </mask>
      <g mask="url(#mask0_986_6136)">
        <circle cx="24" cy="24" r="24" fill="#099171" />
      </g>
    </svg>
  );
}
